import { render, staticRenderFns } from "./TreatmentSetShow.vue?vue&type=template&id=0897bb75&scoped=true&"
import script from "./TreatmentSetShow.vue?vue&type=script&lang=js&"
export * from "./TreatmentSetShow.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSetShow.vue?vue&type=style&index=0&id=0897bb75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897bb75",
  null
  
)

export default component.exports